import { useCallback, useMemo } from 'react'

import { isLiveChatApp } from '../reduxes/slices/live_chat_app/selectors'
import { useSelectorDelegateStore } from '../reduxes/stores/root_store/hooks'

export const mainAppLsId = 'speakeasy'

export const useLocalStorage = () => {
  const liveChatApp = useSelectorDelegateStore(isLiveChatApp)
  const liveChatAppId = useSelectorDelegateStore(
    (state: any) => state.liveChatAppId,
  )
  const prefix = liveChatApp ? `speakeasy_widget_${liveChatAppId}` : mainAppLsId

  const setItem = useCallback(
    (key, value) => {
      const oldState = (JSON.parse(window.localStorage.getItem(prefix) || '{}') || {})
      const newState = {
        ...oldState,
        [key]: value
      }
      return window.localStorage.setItem(prefix, JSON.stringify(newState))
    },
    [prefix],
  )

  const getItem = useCallback(
    (key) => {
      return JSON.parse(window.localStorage.getItem(prefix) || '{}')[key]
    },
    [prefix],
  )

  return useMemo(() => {
    return {
      ...window.localStorage,
      setItem,
      getItem,
    }
  }, [getItem, setItem])
}
